import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/**
 * AuthLink Component
 * Navigation link component for auth pages (e.g., "Don't have an account? Sign Up")
 */
@Component({
  selector: 'app-auth-link',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './auth-link.html',
  styleUrl: './auth-link.scss',
})
export class AuthLink {
  @Input() questionText: string = '';
  @Input() linkText: string = '';
  @Input() linkRoute: string = '';
  @Input() containerClass: string = 'text-center text-sm text-gray-600 mt-3';
  @Input() linkClass: string = 'text-botmaaOrange font-medium hover:underline';
}
